import FINANCIAL_CLASS from './financial-class'
import BUSSINESS_TYPE from './bussiness-type'
import TAKE_STOCK_CLASS from './take-stock-class'
import INVOICE_TYPE from './invoice-type'
import INVENTORY_PROFIT_REASON from './inventory-profit-reason'
import OUT_STORE_REASON from './out-store-reason'
import SALES_AREA from './sales-area'
import OTHER_EXPENSE_TYPE_SETTING from './other-expense-type-setting'
import ITEM_CUSTOM_GROUP from './item-custom-group'
export default {
	'support-archives': {
		id: 'support-archives',
		label: '辅助档案',
		code: '0001_0010',
		child: {
			...FINANCIAL_CLASS,
			...BUSSINESS_TYPE,
			...TAKE_STOCK_CLASS,
			...INVOICE_TYPE,
			...INVENTORY_PROFIT_REASON,
			...OUT_STORE_REASON,
			...SALES_AREA,
			...OTHER_EXPENSE_TYPE_SETTING,
			...ITEM_CUSTOM_GROUP
		}
	}
}
